import { useField } from 'components/common-form/hooks/useField';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedNumber } from 'components/shared/Intl';
import { CurrencySymbol } from 'components/shared/NewAmountInput/CurrencySymbol';
import { MultipleUnitsValueDefinition } from 'models/metadata/readonlyValue.definition';

interface Props {
  node: MultipleUnitsValueDefinition;
}

export function ProductSummaryMultipleUnitsField({ node }: Props) {
  const { data, metadata } = useField<'MultipleUnitsField'>(node.id);
  const translationKey = node.translationKey ?? node.id;
  return (
    <SummaryFieldRow id={node.id} labelKey={translationKey}>
      <div className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        <FormattedNumber maximumFractionDigits={4} value={data?.value ?? undefined} />{' '}
        {data?.valueType && <CurrencySymbol code={metadata.units?.[data.valueType]} />}
      </div>
    </SummaryFieldRow>
  );
}
